import React, { useState, useEffect, useRef } from 'react';
import {
    Paper, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Grid,
    Accordion, AccordionSummary,
    AccordionDetails, Typography, Switch, Container, Button, TextField, Checkbox, Autocomplete,
    Tabs, Tab, Box, Stack, RadioGroup, FormControlLabel, Radio, Card,Backdrop, CircularProgress
} from '@mui/material';
import axios from 'axios';
import { BASE_URL } from "../../App";
import Swal from 'sweetalert2';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';

const styles = {
    dialogTitle: {
        backgroundColor: '#0080FF',
        color: '#fff',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        padding: '10px',
    },
    tableHeaderCell: {
        fontWeight: 'bold',
        backgroundColor: '#f2f2f2',
        padding: '4px',


    },
    customCell: {
        padding: '4px',
    },
    grandTotalCell: {
        textAlign: 'right',
    },
    grandTotalLabel: {
        fontWeight: 'bold',
    },
    grandTotalPopupContent: {
        textAlign: 'center',
    },
    tableRow: {
        fontFamily: 'Times New Roman',
    },

    datePickerWrapper: {
        position: 'relative',
        zIndex: 20,
    },
    datePickerInput: {
        width: '150px',
        height: '40px',
        padding: '8px',
        fontSize: '14px',
        borderRadius: '4px',
        border: '1px solid #ccc',
    },
};
const StyledTextField = styled(TextField)({
    width: '100%',
    maxWidth: '250px',
    '& .MuiInputBase-root': {
        height: '50px',
        fontSize: '16px',
    },
    '& .MuiInputLabel-root': {
        fontSize: '16px',
    },
});
function CSPDMR() {
      const [Loading, setLoading] = React.useState(false);
    const login_id = localStorage.getItem("LOGIN_ID");
    const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");
    const Dealer_code = localStorage.getItem("USER_ID");
    const Dealer_name = localStorage.getItem("USER_NAME");
    const [Cspdmrlist, setCspdmrlist] = useState([]);
    const [academicDetails, setacademicDetails] = useState([]);
    const [previousDetails, setPreviousDetails] = useState([]);
    const [trainingDetailss, settrainingDetailss] = useState([]);
    const [specialDetails, setspecialDetails] = useState([]);
    const [dealers, setdealers] = useState([]);
    const [selecteddealer, setSelecteddealer] = useState(null);
    const [selectedType, setSelectedType] = useState('');
    const options = ['CSP', 'DMR'];
    const [showTable, setShowTable] = useState(true);
    const [editMode, setEditMode] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [expanded1, setExpanded1] = useState(false);
    const [employeeName, setEmployeeName] = useState('');
    const [employeecode, setEmployeecode] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [showacadamicTable, setShowacadamicTable] = useState(true);
    const [weddingdate, setweddingdate] = useState(null);
    const [gender, setGender] = useState(null);
    const genders = ['Male', 'Female'];
    const [mobileno, setMobilno] = useState('');
    const [Phoneno, setPhoneno] = useState('');
    const [email, setEmail] = useState('');
    const [maritalstatus, setMaritalstatus] = useState('');
    const [bloodgroup, setBloodgroup] = useState('');
    const maritalstatusS = ['Single', 'Married'];
    const [Male, setMale] = useState('');
    const [Female, setFemale] = useState('');
    const [Prementadd, setPrementadds] = useState('');
    const [Pressentadd, setPressentadd] = useState('');
    const [Education, setEducation] = useState('');
    const [Course, setCourse] = useState('');
    const [Subject, setSubject] = useState('');
    const [grade, setgrade] = useState('');
    const [nameofcollege, setnameofcollege] = useState('');

    const [Currentjobexprience, setCurrentjobexprience] = useState(null);
    const [Otherjobexprience, setOtherjobexprience] = useState(null);
    const [currentjobnature, setcurrentjobnature] = useState(null);
    const [nameoffirm, setnameoffirm] = useState('');
    const [yearofexp, setyearofexp] = useState('');
    const [showEmployeementTable, setshowEmployeementTable] = useState(true);
    const [selectAll, setSelectAll] = useState(false);
    const [year, setYear] = useState(null);

    const [trainingsubject, settrainingsubject] = useState('');
    const [trainingperiod, settrainingperiod] = useState('');
    const [conductedby, setconductedby] = useState('');
    const [Particulars, setParticulars] = useState('');
    const [showtrainingdetails, setshowtrainingdetails] = useState(true);
    const [showParticulars, setshowParticulars] = useState(true);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleEdit = (detail) => {
        setSelectedRow(detail);
        setEducation(detail.education)
        setCourse(detail.course)
        setSubject(detail.course)
        setnameofcollege(detail.institute)
        setYear(detail.year_passing ? { label: detail.year_passing } : null);
        setgrade(detail.grade)
    };




    const handleFromDateChange = (date) => {
        setDateOfBirth(date);
    };
    const handleWeddingDateChange = (date) => {
       
        setweddingdate(date);
    };
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let i = 1950; i <= currentYear; i++) {
        years.push({ label: i.toString() });
    }

    const handleYearChange = (event, newValue) => {
        setYear(newValue);
    };

    const cspdmrdealerdetails = async () => {
        setLoading(true);
        try {
            const response = await axios.post(BASE_URL + '/cspdmrdealerdetails', { login_id: login_id });
            if (response.status === 200) {
                setLoading(false);
                setCspdmrlist(response.data.cspdmrdealerdetails);
            } 
            else {
                setLoading(false);
                Swal.fire({
                    icon: "warning",
                    text: 'Unexpected response status. Please try again.'
                });
            }
        } catch (error) {
            setLoading(false);
        }
    };

    useEffect(() => {
        
        cspdmrdealerdetails();
    }, [login_id,]);




    const dealer_list = dealers ? dealers.map((type) => ({
        Value: type.DEALER_CODE,
        Label: type.DEALERNAME,
    })) : [];
    const handledealerChange = async (event, newValue) => {
        setSelecteddealer(newValue);
    };


    const handleOpenCard = (rowData) => {
        setEditMode(true);
        openAllAccordions()
        setSelectedRowData(rowData);
        setLoading(true);
        axios
            .post(BASE_URL + '/editcspdmrDetails', {
                code: rowData.Emp_code,
                name: rowData.Emp_name,
                login_id: login_id,
            })
            .then(response => {

                const data = response.data;

                if (data.message === "SUCCESS") {
                    setLoading(false);
                    const personalDetails = data.personalDetail[0];
                    setSelectedType(personalDetails.Profile_type || "");
                    setEmployeecode(personalDetails.Emp_code || "");
                    setEmployeeName(personalDetails.Emp_name || "");
                    setDateOfBirth(personalDetails.dob || "");
                    setGender(personalDetails.Gender || "");
                    setMobilno(personalDetails.Mobileno || "");
                    setPhoneno(personalDetails.Telephoneno || "");
                    setEmail(personalDetails.Email_ID || "");
                    setBloodgroup(personalDetails.Blood_group || "");
                    setMaritalstatus(personalDetails.Mstatus || "");
                    setweddingdate(personalDetails.wedding || "");
                    setMale(personalDetails.Male || "");
                    setFemale(personalDetails.Female || "");
                    setPressentadd(personalDetails.Present_address || "");
                    setPrementadds(personalDetails.Permanent_address || "");
                    setacademicDetails(data.academicDetails && data.academicDetails.length > 0 ? data.academicDetails : []);
                    const employerdetails = data.employerdetails && data.employerdetails.length > 0 ? data.employerdetails[0] : {};
                    setCurrentjobexprience(employerdetails.current_employer || "");
                    setOtherjobexprience(employerdetails.firm || "");
                    setcurrentjobnature(employerdetails.nature_job || "");
                    setPreviousDetails(data.previousDetails && data.previousDetails.length > 0 ? data.previousDetails : []);
                    settrainingDetailss(data.trainingDetails && data.trainingDetails.length > 0 ? data.trainingDetails : []);
                    setspecialDetails(data.specialDetails && data.specialDetails.length > 0 ? data.specialDetails : []);
    
                    console.log("Previous Details:", data.previousDetails);
                } else {
                    setLoading(false);
                    console.error("Failed to fetch data:", data.message);
                }
            })
            .catch(error => {
                setLoading(false);
                console.error("Error fetching data:", error);
            });
            
    };


    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedPanels((prevExpandedPanels) => ({
            ...prevExpandedPanels,
            [panel]: isExpanded, 
        }));
    };

    const openPersonalAccordion = () => {

        sessionStorage.setItem('expandPersonalPanel', 'true');
        window.location.reload();
    };

    useEffect(() => {
        const shouldExpand = sessionStorage.getItem('expandPersonalPanel');

        if (shouldExpand === 'true') {

            setExpandedPanels({ Personal: true });
            sessionStorage.removeItem('expandPersonalPanel');

        }
    }, []);
    const [expandedPanels, setExpandedPanels] = useState({
        Personal: false,
        Academic: false,
        Employee: false,
        Training: false,
        Information: false,
    });

    const openAllAccordions = () => {
        setExpandedPanels({
            Personal: true,
            Academic: true,
            Employee: true,
            Training: true,
            Information: true,
        });
    };
    const handleSelectAll = () => {
        if (selectAll) {
            setPrementadds('')
        } else {
            setPrementadds(Pressentadd);
        }
        setSelectAll(!selectAll);
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(BASE_URL + '/getdealercode', { login_id: login_id });

                if (response.status === 200) {
                    setdealers(response.data.DEALER_CODE);

                    // Optionally, handle response data here
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status from another API.'
                    });
                }
            } catch (error) {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    Swal.fire({
                        icon: "warning",
                        text: 'No response received from the server. Please try again later.'
                    });
                } else {

                }
                console.error('Error:', error.message);
            }
        };

        fetchData();
    }, []);


    const handleSubmit = () => {
        
        setLoading(true);

        if (maritalstatus === "Married") {
            setLoading(false);
            if (!weddingdate) {
                Swal.fire({
                    icon: "error",
                    text: "Wedding date is required for married status!",
                });
                return;
            }
        }
        const formattedWeddingDate = weddingdate ? dayjs(weddingdate).format('DD-MMM-YYYY') : "";
        const data = {
            EmpCode: employeecode,
            Profile_type: selectedType,
            EmpName: employeeName,
            Branch_code: BRANCH_CODE,
            Dealer_code: Dealer_code,
            Dealer_name: Dealer_name,
            Dob: dateOfBirth,
            Gender: gender,
            Mstatus: maritalstatus,
            Wedding: formattedWeddingDate,
            No_of_Children: Male + Female,
            Male: Male,
            Female: Female,
            Present_address: Pressentadd,
            Permanent_address: Prementadd,
            Mobileno: mobileno,
            Telephoneno: Phoneno,
            bloodgroup: bloodgroup,
            emailid: email,
        };

        axios.post(BASE_URL + '/personalinfo', data)
            .then(response => {
                if (response.status === 200) {
                    setLoading(false);
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                    });
                    openAllAccordions()
                }
            })
            .catch(error => {
                if (error.response) {
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        text: `Error: ${error.response.data.message}`,
                    });
                }
            });
    };


    const handleAcademicSubmit = () => {
        setLoading(true);
        const data = {
            EmpCode: employeecode,
            EmpName: employeeName,
            Branch_code: BRANCH_CODE,
            Dealer_code: Dealer_code,
            Dealer_name: Dealer_name,
            Profile_type: selectedType,
            education: Education,
            course: Course,
            subject: Subject,
            institute: nameofcollege,
            year_passing: year?.label || "",
            grade: grade,
        };

        axios.post(BASE_URL + '/education', data)
            .then(response => {
                setLoading(false);
                if (response.status === 200) {
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                    });
                    
                }
            })
            .catch(error => {
                if (error.response) {
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        text: `Error: ${error.response.data.message}`,
                    });
                }
            });
    };
    const handlepreviousSubmit = () => {
        setLoading(true);
        const data = {
            EmpCode: employeecode,
            EmpName: employeeName,
            Dealer_code: Dealer_code,
            Dealer_name: Dealer_name,
            Profile_type: selectedType,
            firm: nameoffirm,
            years: yearofexp,
        };

        axios.post(BASE_URL + '/previous', data)
            .then(response => {
                if (response.status === 200) {
                    setLoading(false);
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        text: `Error: ${error.response.data.message}`,
                    });
                }
            });
    };

    const handletrainingSubmit = () => {
        setLoading(true);
        const data = {
            EmpCode: employeecode,
            EmpName: employeeName,
            Dealer_code: Dealer_code,
            Dealer_name: Dealer_name,
            Profile_type: selectedType,
            subject: trainingsubject,
            period: trainingperiod,
            conducted_by: conductedby,
            Branch_code: BRANCH_CODE,
        };

        axios.post(BASE_URL + '/training', data)
            .then(response => {
                if (response.status === 200) {
                    setLoading(false);
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        text: `Error: ${error.response.data.message}`,
                    });
                }
            });
    };

    const handlespecialSubmit = () => {
        setLoading(true);
        const data = {
            EmpCode: employeecode,
            EmpName: employeeName,
            Dealer_code: Dealer_code,
            Dealer_name: Dealer_name,
            Profile_type: selectedType,
            particular: Particulars
        };

        axios.post(BASE_URL + '/special', data)
            .then(response => {
                if (response.status === 200) {
                    setLoading(false);
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        text: `Error: ${error.response.data.message}`,
                    });
                }
            });
    };

    const handlepresentSubmit = () => {
        setLoading(true);
        const data = {
            EmpCode: employeecode,
            EmpName: employeeName,
            Dealer_code: Dealer_code,
            Dealer_name: Dealer_name,
            Profile_type: selectedType,
            current_employer: Currentjobexprience,
            firm: Otherjobexprience,
            nature_job: currentjobnature
        };

        axios.post(BASE_URL + '/present', data)
            .then(response => {
                if (response.status === 200) {
                    setLoading(false);
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        text: `Error: ${error.response.data.message}`,
                    });
                }
            });
    };

    return (

        <div className="container">
            <br></br><br></br>

            <Card
                className="shadow bg-white rounded"
                sx={{
                    padding: 3, // Add padding inside the card
                    width: '100%',
                }}
            >
                <Box
                    component="form"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3, // Space between elements inside the card
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <Grid container spacing={2}>
                        {/* Dealer Selection */}
                        <Grid item xs={12} md={6}>
                            <Autocomplete
                                options={dealer_list}
                                getOptionLabel={(option) => option.Label}
                                value={selecteddealer}
                                onChange={handledealerChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Dealers"
                                        variant="outlined"
                                        required
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>

                        {/* Profile Type Selection */}
                        <Grid item xs={12} md={6}>
                            <Autocomplete
                                value={selectedType}
                                onChange={(event, newValue) => setSelectedType(newValue)}
                                options={options}
                                renderInput={(params) => (
                                    <TextField {...params} label="Profile Type" fullWidth />
                                )}
                                disabled={editMode}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Button variant="contained" color="primary" onClick={openPersonalAccordion} >New Add</Button>
                        </Grid>

                    </Grid>
                </Box>
            </Card>

            <br></br>
            {showTable && (
                <div>


                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>S.No</TableCell>
                                    <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>EMPLOYEE CODE</TableCell>
                                    <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>PROFILE</TableCell>
                                    <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Name</TableCell>
                                    <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>DATE OF BIRTH</TableCell>
                                    <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>MOBILE NUMBER</TableCell>
                                    <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Cspdmrlist && Cspdmrlist.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{index + 1}</TableCell>
                                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.Emp_code}</TableCell>
                                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.Profile_type}</TableCell>
                                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.Emp_name}</TableCell>
                                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.Dob}</TableCell>
                                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.Mobileno}</TableCell>
                                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>
                                            <Button variant="contained" onClick={() => handleOpenCard(row)} color="primary" >Edit</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            )}

            <br />
            <Grid item xs={12}>
                <Accordion expanded={expandedPanels.Personal} onChange={handleAccordionChange('Personal')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="invoice-ewaybill-content"
                        id="invoice-ewaybill-header"
                        sx={{
                            backgroundColor: expanded1 === 'Personal' ? '#f0e68c' : 'inherit', // Add color when expanded
                        }}
                    >

                        <Typography variant="subtitle1">Personal Information</Typography>

                    </AccordionSummary>

                    <AccordionDetails>

                        <Grid container spacing={2}>
                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Name of Employee"
                                    variant="outlined"
                                    value={employeeName}
                                    onChange={(e) => setEmployeeName(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4} >
                                <div style={styles.datePickerWrapper}>
                                    <DatePicker
                                        selected={dateOfBirth}
                                        onChange={handleFromDateChange}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        dropdownMode="select"
                                        customInput={<StyledTextField variant="outlined" label="Date of Birth" />}
                                    /></div>
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <Autocomplete
                                    options={genders}
                                    value={gender}
                                    onChange={(event, newValue) => setGender(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Gender Type" variant="outlined" />}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Mobile NO"
                                    variant="outlined"
                                    value={mobileno}
                                    onChange={(e) => setMobilno(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Phone NO"
                                    variant="outlined"
                                    value={Phoneno}
                                    onChange={(e) => setPhoneno(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Email"
                                    variant="outlined"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Blood Group"
                                    variant="outlined"
                                    value={bloodgroup}
                                    onChange={(e) => setBloodgroup(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <Autocomplete
                                    options={maritalstatusS}
                                    value={maritalstatus}
                                    onChange={(event, newValue) => setMaritalstatus(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Marital Status" variant="outlined" />}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <div style={styles.datePickerWrapper}>
                                    <DatePicker
                                        selected={weddingdate}
                                        onChange={handleWeddingDateChange}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        dropdownMode="select"
                                        customInput={<StyledTextField variant="outlined" label="Wedding Date" />}
                                    /></div>
                            </Grid>

                            <Grid item xs={6} md={6} lg={6}  >
                                <TextField
                                    fullWidth
                                    label="Number of Child(Male)"
                                    variant="outlined"
                                    value={Male}
                                    onChange={(e) => setMale(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={6} lg={6}  >
                                <TextField
                                    fullWidth
                                    label="Number of Child(Female)"
                                    variant="outlined"
                                    value={Female}
                                    onChange={(e) => setFemale(e.target.value)}
                                />
                            </Grid>


                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Present Address"
                                    variant="outlined"
                                    value={Pressentadd}
                                    onChange={(e) => setPressentadd(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <FormControlLabel
                                    control={<Checkbox size="small" checked={selectAll} onChange={handleSelectAll} />}
                                    label="Present address Same as Permenent Address"
                                />
                            </Grid>
                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Perment Adderss"
                                    variant="outlined"
                                    value={Prementadd}
                                    onChange={(e) => setPrementadds(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <center>
                                <Button variant="contained" color="primary" onClick={handleSubmit} >Proceed</Button></center>
                            </Grid>

                        </Grid>

                    </AccordionDetails>
                </Accordion>
            </Grid>
            <br></br>


            <Grid item xs={12}>
                <Accordion expanded={expandedPanels.Academic} onChange={handleAccordionChange('Academic')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="invoice-ewaybill-content"
                        id="invoice-ewaybill-header"
                        sx={{
                            backgroundColor: expanded1 === 'Academic' ? '#f0e68c' : 'inherit', // Add color when expanded
                        }}
                    >

                        <Typography variant="subtitle1">Academic Qualification</Typography>

                    </AccordionSummary>

                    <AccordionDetails>

                        <Grid container spacing={2}>
                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Education"
                                    variant="outlined"
                                    value={Education}
                                    onChange={(e) => setEducation(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4} >
                                <TextField
                                    fullWidth
                                    label="Course"
                                    variant="outlined"
                                    value={Course}
                                    onChange={(e) => setCourse(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Subject"
                                    variant="outlined"
                                    value={Subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Name of School/College"
                                    variant="outlined"
                                    value={nameofcollege}
                                    onChange={(e) => setnameofcollege(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <Autocomplete
                                    options={years}
                                    getOptionLabel={(option) => option.label}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Year of Passing" variant="outlined" />
                                    )}
                                    value={year}
                                    onChange={handleYearChange}
                                    style={{ width: 300 }}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Grade/%/CGPA "
                                    variant="outlined"
                                    value={grade}
                                    onChange={(e) => setgrade(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6}   >
                             <center>   <Button size="small" variant="contained" onClick={handleAcademicSubmit}   ><b>ADD</b></Button></center>
                            </Grid>
                            <Grid item xs={12}  >
                                {showacadamicTable && (
                                    <div>
                                        <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>S.No</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>CODE</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>NAME</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>EDUCATION</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>COURSE</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>SUBJECT</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>NAME OF SCHOOL/COLLEGE</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>YEAR OF PASSING</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Grade/%/CGPA</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Actions</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>

                                                    {academicDetails && academicDetails.map((detail, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                {detail.emp_code}
                                                            </TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                {detail.emp_name}
                                                            </TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                {detail.education}
                                                            </TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                {detail.course}
                                                            </TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                {detail.subject || ""}
                                                            </TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                {detail.institute || ""}
                                                            </TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                {detail.year_passing || ""}
                                                            </TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                {detail.grade || ""}
                                                            </TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() => handleEdit(detail)}
                                                                >
                                                                    Edit
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </Grid>


                        </Grid>

                    </AccordionDetails>
                </Accordion>
            </Grid>



            <br></br>
            <Grid item xs={12}>
                <Accordion expanded={expandedPanels.Employee} onChange={handleAccordionChange('Employee')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="invoice-ewaybill-content"
                        id="invoice-ewaybill-header"
                        sx={{
                            backgroundColor: expanded1 === 'Employee' ? '#f0e68c' : 'inherit', // Add color when expanded
                        }}
                    >

                        <Typography variant="subtitle1">Employee Details</Typography>

                    </AccordionSummary>

                    <AccordionDetails>

                        <Grid container spacing={2}>
                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Current Employer Experience (in Years)"
                                    variant="outlined"
                                    value={Currentjobexprience}
                                    onChange={(e) => setCurrentjobexprience(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4} >
                                <TextField
                                    fullWidth
                                    label="Other Firm Experience (in Years)"
                                    variant="outlined"
                                    value={Otherjobexprience}
                                    onChange={(e) => setOtherjobexprience(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Current Job Natures"
                                    variant="outlined"
                                    value={currentjobnature}
                                    onChange={(e) => setcurrentjobnature(e.target.value)}
                                />
                            </Grid>
                            <br></br>
                            <Grid item xs={6}>
                <center>
                <Button size="small" variant="contained" onClick={handlepresentSubmit}   ><b>Submit</b></Button></center>
            </Grid>
            <br></br>

                            <Grid item xs={12}>
                                <center>
                                    <h5 style={{ fontWeight: '1000' }}>
                                        <i>Previous Job Details</i>
                                    </h5>
                                </center>
                            </Grid>
                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Name of the Firm (Prevoious Job)"
                                    variant="outlined"
                                    value={nameoffirm}
                                    onChange={(e) => setnameoffirm(e.target.value)}
                                />
                            </Grid>



                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Year of Experience "
                                    variant="outlined"
                                    value={yearofexp}
                                    onChange={(e) => setyearofexp(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={6}   >
                                <center>
                                <Button size="small" variant="contained" onClick={handlepreviousSubmit}   ><b>ADD</b></Button></center>
                            </Grid>
                            <br /> <br />
                            <Grid item xs={12}   >
                                {showEmployeementTable && (
                                    <div>


                                        <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>NAME OF FIRM</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>YEAR OF EXPERIENCE</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {previousDetails.length > 0 ? (
                                                        previousDetails.map((detail, index) => (
                                                            
                                                            <TableRow key={index}>
                                                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                    {detail.firm}
                                                                </TableCell>
                                                                <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                                                                    {detail.years}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={2} style={{ padding: '10px', background: '#e3fafe', textAlign: 'center' }}>
                                                                No previous details available
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </Grid>

                        </Grid>

                    </AccordionDetails>
                </Accordion>
            </Grid>
            <br></br>
            <Grid item xs={12}>
                <Accordion expanded={expandedPanels.Training} onChange={handleAccordionChange('Training')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="invoice-ewaybill-content"
                        id="invoice-ewaybill-header"
                        sx={{
                            backgroundColor: expanded1 === 'Training' ? '#f0e68c' : 'inherit', // Add color when expanded
                        }}
                    >

                        <Typography variant="subtitle1">Training Attended</Typography>

                    </AccordionSummary>

                    <AccordionDetails>

                        <Grid container spacing={2}>
                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Trainingsubject"
                                    variant="outlined"
                                    value={trainingsubject}
                                    onChange={(e) => settrainingsubject(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6} md={4} lg={4} >
                                <TextField
                                    fullWidth
                                    label="Trainingperiod"
                                    variant="outlined"
                                    value={trainingperiod}
                                    onChange={(e) => settrainingperiod(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6} md={4} lg={4} >
                                <TextField
                                    fullWidth
                                    label="Conducted By"
                                    variant="outlined"
                                    value={conductedby}
                                    onChange={(e) => setconductedby(e.target.value)}
                                />
                            </Grid>



                            <Grid item xs={6}   >
                               <center><Button size="small" variant="contained" onClick={handletrainingSubmit}  ><b>ADD</b></Button></center> 
                            </Grid>
                            <br /> <br />
                            <Grid item xs={12}   >
                                {showtrainingdetails && (
                                    <div>
                                        <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>

                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>CODE</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>SUBJECT</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>PERIOD</TableCell>
                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>CONDUCTED BY</TableCell>

                                                    </TableRow>
                                                </TableHead>

                                                {trainingDetailss && trainingDetailss.map((train, index) => (
                                                    <TableBody>

                                                        <TableRow key={index}>

                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{train.emp_code}</TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{train.subject}</TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{train.period}</TableCell>
                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{train.conducted_by}</TableCell>

                                                        </TableRow>
                                                    </TableBody>
                                                ))}
                                            </Table>
                                        </TableContainer>
                                    </div>

                                )}
                            </Grid>

                        </Grid>

                    </AccordionDetails>
                </Accordion>
            </Grid>
            <br></br>
            <Grid item xs={12}>
                <Accordion expanded={expandedPanels.Information} onChange={handleAccordionChange('Information')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="invoice-ewaybill-content"
                        id="invoice-ewaybill-header"
                        sx={{
                            backgroundColor: expanded1 === 'Information' ? '#f0e68c' : 'inherit', // Add color when expanded
                        }}
                    >

                        <Typography variant="subtitle1">Special Interest/Information (if any)</Typography>

                    </AccordionSummary>

                    <AccordionDetails>

                        <Grid container spacing={2}>
                            <Grid item xs={6} md={4} lg={4}  >
                                <TextField
                                    fullWidth
                                    label="Particulars"
                                    variant="outlined"
                                    value={Particulars}
                                    onChange={(e) => setParticulars(e.target.value)}
                                />
                            </Grid>





                            <Grid item xs={6}   >
                              <center> <Button size="small" variant="contained" onClick={handlespecialSubmit} ><b>ADD</b></Button></center> 
                            </Grid>
                            <br /> <br />
                            <Grid item xs={12}   >
                                {showParticulars && (
                                    <div>
                                        <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>

                                                        <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', textAlign: 'center' }}>PARTICULARS</TableCell>


                                                    </TableRow>
                                                </TableHead>
                                                {specialDetails && specialDetails.map((special, index) => (
                                                    <TableBody>

                                                        <TableRow key={index} >

                                                            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textAlign: 'center' }}>{special.particular}</TableCell>


                                                        </TableRow>
                                                    </TableBody>
                                                ))}
                                            </Table>
                                        </TableContainer>
                                    </div>

                                )}
                            </Grid>

                        </Grid>

                    </AccordionDetails>
                </Accordion>
            </Grid>
            <br></br>

          


            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={Loading} >
        <CircularProgress color="inherit" />
      </Backdrop>
        </div>




    )


}

export default CSPDMR;